import React, { Dispatch, SetStateAction, useState } from "react";
import { Button, Stack } from "@mui/material";
import ModalBase from "../../../components/common/modal/ModalBase";
import TextInput from "../../../components/common/input/TextInput";
import { LoadingButton } from "@mui/lab";
import { asyncPostData } from "../../../utils/httpRequests";
import { useSelector } from "react-redux";
import { useAlertContext } from "../../../contexts/alert/AlertProvider";

interface ISaveResult {
  title: string;
  apiCode: string;
  condition: { [key: string]: any };
  setLoad: Dispatch<SetStateAction<number>>;
}

function SaveResult({ title, apiCode, condition, setLoad }: ISaveResult) {
  const { showAlert } = useAlertContext();
  const token = useSelector((state: any) => state.auth.token);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [text, setText] = useState<string>("");

  const handleCloseModal = () => {
    setOpenModal(false);
    setText("");
  };

  const handleSave = async () => {
    if (loading) return;
    setLoading(true);
    const resp = await asyncPostData({
      apiCode,
      token,
      data: { key: text, name: text },
      condition: { q: condition },
      extraUrl: "/updateskeysearch",
    });
    if (!resp || resp?.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error ||
          resp?.data?.message ||
          "Lỗi khi lưu kết quả tìm kiếm",
      });
      setLoading(false);
      return;
    }
    showAlert({
      type: "success",
      message: "Lưu thành công",
    });
    setLoad((prev) => prev + 1);
    handleCloseModal();
    setLoading(false);
  };

  return (
    <>
      {openModal && (
        <ModalBase
          title={title}
          open={openModal}
          handleClose={handleCloseModal}
          width="400px"
          actions={[
            <Stack key={1} direction="row" justifyContent="flex-end" gap={1}>
              <LoadingButton
                onClick={handleSave}
                loading={loading}
                variant="contained"
                sx={{
                  boxShadow: "none",
                  textTransform: "none",
                  color: "common.white",
                  "&:hover": { boxShadow: "none" },
                }}
              >
                Lưu
              </LoadingButton>
            </Stack>,
          ]}
        >
          <Stack sx={{ px: 2 }}>
            <TextInput
              direction="column"
              label="Tên"
              placeholder="Đặt tên cho kết quả"
              value={text}
              onChange={(e) => setText(e.target.value as string)}
            />
          </Stack>
        </ModalBase>
      )}
      {/* Button */}
      <Button
        onClick={() => setOpenModal(true)}
        variant="contained"
        size="small"
        color="success"
        sx={{
          boxShadow: "none",
          textTransform: "none",
          color: "common.white",
          "&:hover": { boxShadow: "none" },
        }}
      >
        Lưu kết quả
      </Button>
    </>
  );
}

export default SaveResult;
